import styled from "styled-components";
import { Small } from "@/lib/styles";

export const Label = styled(Small)`
  display: block;
  margin-top: 1rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.darkMiddle};
  font-weight: 400;
  line-height: 1.6;
`;

export const Value = styled(Small)`
  display: block;
  margin-top: 0.5rem;
  line-height: 1.6;
  font-weight: 700;
`;
